import axios from "utils/axios";
import { routes } from "api/routes";

export const apiGetTradesHistory = async (formData) => {
  const { data } = await axios.post(routes.getTradesHistory, formData);
  return data;
};

export const apiTriggerCloseTrade = async (formData) => {
  const { data } = await axios.post(routes.triggerCloseTrade, formData);
  return data;
};

// semi-automation buy proposals
export const apiApproveBuyProposal = async (dealId) => {
  const { data } = await axios.post(routes.approveBuyProposal, { dealId });
  return data;
};

export const apiRejectBuyProposal = async (dealId) => {
  const { data } = await axios.post(routes.rejectBuyProposal, { dealId });
  return data;
};

// instrument: "stock" (default), "option" or "all"; startDate: "YYYY-MM-DD"
// limits the closed-trade stats (open positions are always the current ones)
export const apiGetPerformanceStats = async (
  accountType,
  instrument,
  startDate,
) => {
  const { data } = await axios.get(routes.getPerformanceStats, {
    params: {
      accountType,
      ...(instrument && { instrument }),
      ...(startDate && { startDate }),
    },
  });
  return data;
};
